// src/DisponibilePage.jsx
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API_BASE } from './api';

export default function DisponibilePage() {
  const { t } = useTranslation();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    const sp = new URLSearchParams(window.location.search);
    const token = sp.get('token');
    if (!token) { setStatus('error'); return; }
    fetch(`${API_BASE}/availability/confirm`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ token }),
    })
      .then(r => r.json())
      .then(data => {
        if (data?.ok) setStatus('ok');
        else if (data?.error === 'expired') setStatus('expired');
        else setStatus('error');
      })
      .catch(() => setStatus('error'));
  }, []);

  const messages = {
    loading: { icon: '⏳', title: t('dispon.loading_title'), text: '' },
    ok:      { icon: '✅', title: t('dispon.ok_title'),      text: t('dispon.ok_text') },
    expired: { icon: '⏰', title: t('dispon.expired_title'), text: t('dispon.expired_text') },
    error:   { icon: '❌', title: t('dispon.error_title'),   text: t('dispon.error_text') },
  };

  const { icon, title, text } = messages[status];

  return (
    <div style={{minHeight:'100vh',background:'#07070a',display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'Inter, sans-serif',padding:'24px'}}>
      <div style={{maxWidth:'460px',width:'100%',background:'#0f0f17',border:'1px solid rgba(212,165,80,0.15)',borderRadius:'16px',padding:'48px 40px',textAlign:'center'}}>
        <div style={{fontFamily:'Kanit, sans-serif',fontSize:'22px',fontWeight:800,color:'#d4a550',letterSpacing:'0.15em',marginBottom:'32px'}}>JKL</div>
        <div style={{fontSize:'40px',marginBottom:'20px'}}>{icon}</div>
        <h2 style={{fontFamily:'Kanit, sans-serif',fontWeight:700,fontSize:'22px',color:'#f0ece4',margin:'0 0 12px'}}>{title}</h2>
        {text && <p style={{color:'#8a8a9a',fontSize:'14px',lineHeight:1.7,margin:'0 0 28px'}}>{text}</p>}
        <a href="/" style={{display:'inline-block',padding:'12px 28px',background:'#d4a550',color:'#07070a',borderRadius:'6px',fontFamily:'Kanit, sans-serif',fontWeight:700,fontSize:'13px',letterSpacing:'0.08em',textTransform:'uppercase',textDecoration:'none'}}>
          {t('dispon.cta')}
        </a>
      </div>
    </div>
  );
}
